import ReactVisibilitySensor from "react-visibility-sensor";
import BorderCenterLabel, { BoxPropsType } from "../../Labels/BorderCenterLabel";
import TitleBorderLeft from "../../Text/TitleBorderLeft";

type PrimaryColoredSectionPropType = {
    bg? : number;
    info? : {
        title : string;
        paragraphOne : string,
        paragraphTwo? : string,
    },
    card? : {
        image? : {
            src? : string,
            alt? : string,
        },
        paragraphOne? : string;
        paragraphTwo? : string;
    },
    title? : string,
    labels? : BoxPropsType[][];
    customerImageClass? : string;
}

const PrimaryColoredSection = ({ 
    bg = 1,
    customerImageClass,
    info,
    card,
    title,
    labels,
} : PrimaryColoredSectionPropType) => {
  return (
    <div className="primary-colored-section">
        <div className="section-header">
            <div className={`background ${bg === 2 ? "secondary" : ""}`}>
            </div>
            <div className="wrapper-small">
                <div className="section-header-flex">
                    <div className={`card-wrapper an-move-top-5`}>
                        <div className="primary-card">
                            <div className="card-header">
                                <img 
                                    src={card?.image?.src} 
                                    className={`card-image ${customerImageClass}`} 
                                    alt={card?.image?.src} 
                                />
                            </div>
                            {card?.paragraphOne && card.paragraphTwo ?
                            <div className="card-body">
                                <p className="card-subtitle">{card?.paragraphOne}</p>
                                <p className="card-subtitle">{card?.paragraphTwo}</p>
                            </div> :
                            ""
                            }
                        </div>
                    </div>
                    <div className='info-box'>
                        <h3 className="title">{info?.title}</h3>
                        <p className="subtitle">{info?.paragraphOne}</p>
                        <p className="subtitle">{info?.paragraphTwo}</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="wrapper-small">
            {title ? <TitleBorderLeft>{title}</TitleBorderLeft> : ""}
            
        </div>
        {
        labels?.map((item,index) => (
            <BorderCenterLabel 
                key={index}
                boxes={item}
            />
        ))
        }
    </div>
  )
}

export default PrimaryColoredSection